import { VPagination } from 'vuetify/lib/components/VPagination';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-2 ml-auto div-pagination"},[_c(VPagination,_vm._b({attrs:{"color":"#6170E8","rounded":"","variant":"outlined"},on:{"input":function($event){return _vm.$emit('input', $event)}}},'v-pagination',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }